import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sat-admin-delete-dialog',
  templateUrl: './sat-admin-delete-dialog.component.html',
  styleUrls: ['./sat-admin-delete-dialog.component.scss'],
  standalone: false,
})
export class SatAdminDeleteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SatAdminDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { subscriptionIdentifier: string }
  ) {}

  /* istanbul ignore next */
  cancelDelete() {
    this.dialogRef.close(false);
  }

  /* istanbul ignore next */
  confirmDelete() {
    this.dialogRef.close(true);
  }
}
